/* eslint-disable no-nested-ternary */
import { Tooltip } from 'react-tooltip';
import { formatNumber } from 'utils/formats';
import { useTranslate } from 'hooks/useTranslate';

import '../PartnerBook.scss';

function PlanSummaryBeneficiaryMainTable({
  view,
  summary,
  names,
  emails,
  cifs,
  isFormatted = true,
}) {
  const { t } = useTranslate();

  const formatValue = (value) => (isFormatted ? formatNumber(value) : value);

  return (
    summary && (
      <div className={view === 2 ? 'nk-block' : 'd-none'}>
        <div className="card card-bordered">
          <div className="table-responsive">
            <table
              className="table table-striped text-right border-right partner-book-table"
              id="beneficiarySummaryTable"
            >
              <tr className="text-center table-header">
                <th className="w-200px border-right">{t('Beneficiaries')}</th>
                <th className="w-150px table-subheader border-right">
                  {t('Email')}
                </th>
                <th className="w-150px table-subheader border-right">
                  {t('CIF')}
                </th>
                <th className="no-break table-subheader border-right">
                  {t('AssignedUnits')}
                </th>
                <th className="no-break table-subheader border-right">
                  {t('Vested')}
                </th>
                <th className="no-break table-subheader border-right">
                  {t('CanceledUnits')}
                </th>
                <th className="no-break table-subheader border-right">
                  {t('Acquired')}
                </th>
              </tr>

              {Object.keys(summary)?.map((beneficiaryId, index) => (
                <tr key={`summary-row-${beneficiaryId}`}>
                  <td
                    id={beneficiaryId}
                    className="text-left w-200px text-ellipsis border-right"
                  >
                    {names[beneficiaryId]}
                    <Tooltip anchorId={beneficiaryId} place="bottom">
                      {names[beneficiaryId]}
                    </Tooltip>
                  </td>
                  <td className="text-left w-150px text-ellipsis border-right">
                    {emails[beneficiaryId]}
                  </td>
                  <td className="text-left w-150px text-ellipsis border-right">
                    {cifs[beneficiaryId]}
                  </td>

                  {Object.values(summary[beneficiaryId]).map((value) => (
                    <td
                      className={
                        index === 0
                          ? 'text-right text-ellipsis border-right'
                          : 'text-right border-right'
                      }
                    >
                      {formatValue(value)}
                    </td>
                  ))}
                </tr>
              ))}
            </table>
          </div>
        </div>
      </div>
    )
  );
}

export default PlanSummaryBeneficiaryMainTable;
